<template>
    <Layout disable-vertical-padding disable-horizontal-padding>
        <div v-bind:class="$style.hero">
            <h1>Comment Anywhere.</h1>
            <p>Disabled comments? No comments? No worries...</p>
            <p>CitizenJ is a Chrome extension making comments available on any webpage.</p>
            <a href="https://chrome.google.com/webstore/detail/citizenj-comment-on-any-w/lgcapmfoacjdejiahggcolllphnpgbcb"><button>Download Extension</button></a>
        </div>
        <div v-bind:class="$style.featured">
            <WebsiteCard
                v-for="card in featuredCards"
                v-bind:key="card.id"
                v-bind:card="card"
                featured
                v-bind:class="$style.featured__card"
            />
        </div>

        <div v-bind:class="$style.websites">
            <WebsiteCard
                v-for="card in cards"
                v-bind:key="card.id"
                v-bind:card="card"
                v-bind:class="$style.websites__card"
            />
        </div>
    </Layout>
</template>

<script>
    import Layout from '@layouts/main';
    import WebsiteCard from '@components/WebsiteCard';

    export default {
        /**
         * Custom page meta data property for the view components.
         *
         * @type {Object}
         */
        metaInfo: {
            title: 'Citizen J.',
            meta: [
                {
                    name: 'description',
                    content: 'Citizen J. | Comment Anywhere on the Uncensored Web',
                },
            ],
            link: [
                {
                    rel: 'canonical',
                    href: '/',
                },
            ],
        },

        /**
         * Declaratively register required components.
         *
         * @link https://vuejs.org/v2/guide/components.html#Local-Registration
         */
        components: {
            Layout,
            WebsiteCard,
        },

        /**
         * You must define defaults for all Vue models and reactive Vue template data.
         *
         * @link https://vuejs.org/v2/api/#data
         *
         * @return Object Vue model and binding defaults.
         */
        data () {
            return {
                cards: [],
                featuredCards: [],
            };
        },

        /**
         * This method logic will be run immediately after the Vue instance is created.
         *
         * @link https://vuejs.org/v2/guide/instance.html#Lifecycle-Diagram
         */
        created () {
            this.axios.get('/websites').then(({ data }) => (this.cards = data));

            this.axios.get('/websites?featured=true').then(({ data }) => (this.featuredCards = data));
        },
    };
</script>

<style lang="scss" module>
    @import '@design';

    .hero {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: calc(100vh - 8rem);
        text-align: center;
        background: #282B57;

        p:first-of-type {
            margin-top: 1rem;
            font-size: 2rem;
            font-weight: 900;
            line-height: 1;
            color: #EF4141;
        }

        p:nth-of-type(2) {
            font-size: 1.25rem;
            color: #FFF;
        }

        h1 {
            @apply my-0;
            font-size: 3.5rem;
            font-weight: 900;
            line-height: 1;
            color: white;

            @screen lg {
                font-size: 8rem;
            }
        }

        button {
            padding: 2rem 4rem;
            margin-top: 3rem;
            font-size: 1.25rem;
            font-weight: 900;
            color: white;
            text-align: center;
            border: 1px solid white;

            @screen lg {
                padding: 2rem 4rem;
                font-size: 1.5rem;
            }
        }
    }

    .featured {
        @apply flex -mx-2 px-10 py-6 bg-gray-400;
    }

    .featured__card {
        @apply flex-1;
    }

    .websites {
        @apply flex flex-wrap px-10 py-6 -mx-2;
    }

    .websites__card {
        @apply w-1/3 m-0 py-6;
    }
</style>
